import React, { useState } from "react";
import DataTable from "react-data-table-component";

// Custom Styles (Optional)
const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#007bff",
      color: "white",
      fontSize: "16px",
    },
  },
};

// Static Data
const data = [
  { id: 1, name: "John Doe", email: "john@example.com", age: 28 },
  { id: 2, name: "Jane Smith", email: "jane@example.com", age: 32 },
  { id: 3, name: "Michael Johnson", email: "michael@example.com", age: 24 },
  { id: 4, name: "Emily Davis", email: "emily@example.com", age: 30 },
  { id: 5, name: "David Wilson", email: "david@example.com", age: 27 },
  { id: 6, name: "Sarah Brown", email: "sarah@example.com", age: 35 },
  { id: 7, name: "Chris Miller", email: "chris@example.com", age: 29 },
  { id: 8, name: "Amanda White", email: "amanda@example.com", age: 26 },
  { id: 9, name: "Robert Clark", email: "robert@example.com", age: 33 },
  { id: 10, name: "Lisa Anderson", email: "lisa@example.com", age: 31 },
  { id: 1, name: "John Doe", email: "john@example.com", age: 28 },
  { id: 2, name: "Jane Smith", email: "jane@example.com", age: 32 },
  { id: 3, name: "Michael Johnson", email: "michael@example.com", age: 24 },
  { id: 4, name: "Emily Davis", email: "emily@example.com", age: 30 },
  { id: 5, name: "David Wilson", email: "david@example.com", age: 27 },
  { id: 6, name: "Sarah Brown", email: "sarah@example.com", age: 35 },
  { id: 7, name: "Chris Miller", email: "chris@example.com", age: 29 },
  { id: 8, name: "Amanda White", email: "amanda@example.com", age: 26 },
  { id: 9, name: "Robert Clark", email: "robert@example.com", age: 33 },
  { id: 10, name: "Lisa Anderson", email: "lisa@example.com", age: 31 },
  { id: 1, name: "John Doe", email: "john@example.com", age: 28 },
  { id: 2, name: "Jane Smith", email: "jane@example.com", age: 32 },
  { id: 3, name: "Michael Johnson", email: "michael@example.com", age: 24 },
  { id: 4, name: "Emily Davis", email: "emily@example.com", age: 30 },
  { id: 5, name: "David Wilson", email: "david@example.com", age: 27 },
  { id: 6, name: "Sarah Brown", email: "sarah@example.com", age: 35 },
  { id: 7, name: "Chris Miller", email: "chris@example.com", age: 29 },
  { id: 8, name: "Amanda White", email: "amanda@example.com", age: 26 },
  { id: 9, name: "Robert Clark", email: "robert@example.com", age: 33 },
  { id: 10, name: "Lisa Anderson", email: "lisa@example.com", age: 31 },
];

const DataTableComponent = () => {
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const [rowsPerPage, setRowsPerPage] = useState(5); // Default rows per page

  // Search function
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    setFilteredData(
      data.filter((row) => row.name.toLowerCase().includes(value))
    );
  };

  // Define table columns
  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Email", selector: (row) => row.email },
    { name: "Age", selector: (row) => row.age, sortable: true },
  ];

  return (
    <div>
      <h2>React Data Table with Pagination & Search</h2>

      {/* Search Input */}
      <input
        type="text"
        placeholder="Search by name..."
        value={search}
        onChange={handleSearch}
        style={{
          marginBottom: "10px",
          padding: "5px",
          width: "200px",
        }}
      />

      {/* Data Table */}
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        paginationPerPage={rowsPerPage} // Default rows per page
        paginationRowsPerPageOptions={[5, 10, 15, 20]} // Dropdown for row selection
        highlightOnHover
        customStyles={customStyles}
        onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
      />
    </div>
  );
}; 

export default DataTableComponent;
